import { Routes } from '@angular/router';
import { AdminComponent } from './layout/admin/admin.component';
import { AuthComponent } from './layout/auth/auth.component';
import { EmptyComponent } from './layout/empty/empty.component';
import { MenuItems } from './shared/menu-items/menu-items';

export const AppRoutes: Routes = [
  {
    path: '',
    component: AdminComponent,
    children: [
      {
        path: '',
        redirectTo: '/empty',
        pathMatch: 'full'
      },
      {
        path: 'process',
        loadChildren: './pages/process/process.module#ProcessModule',
        canActivate: [MenuItems]
      },
      {
        path: 'project',
        loadChildren: './pages/project/project.module#ProjectModule',
        canActivate: [MenuItems]
      },
      {
        path: 'empty',
        loadChildren: './layout/empty/empty.module#EmptyModule'
      }, {
        path: 'authority',
        loadChildren: './pages/authority/authority.module#AuthorityModule',
        canActivate: [MenuItems]
      }
    ]
  },
  {
    path: '',
    component: AuthComponent,
    children: [
      {
        path: '',
        redirectTo: '/empty',
        pathMatch: 'full'
      },
      {
        path: 'page',
        loadChildren: './pages/authentication/authentication.module#AuthenticationModule'
      }
    ]
  },
  {
    path: '',
    redirectTo: '/page/login',
    pathMatch: 'full'
  }
];



// WEBPACK FOOTER //
// /Users/liyankai/Documents/github/seiya_web.git/src/app/app.routing.ts